import React from "react";
import BaseDivideLine from "../../../../components/BaseDivideLine";
import RemoveGame from "../RemoveGame";
import BaseButton from "../../../../components/BaseButton";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./style.scss";
import ROUTES from "../../../../utils/routes";

export default function UnpurchasedNewGame({ game, buyGame, removeGame }) {
  UnpurchasedNewGame.propTypes = {
    game: PropTypes.object,
    buyGame: PropTypes.func,
    removeGame: PropTypes.func,
  };
  const { t } = useTranslation();
  return (
    <div key={game.id} className="action-purchase-game">
      <BaseDivideLine dash={true} top={true} />
      <div className="action-purchase-game__container">
        <div className="action-purchase-game__info">
          <div className="action-purchase-game__info__title">
            <span>{t(game.name)}</span>
          </div>
          <span className="action-purchase-game__info__tip">
            {t("personal_acc.invite_desc")}
          </span>
          <div className="action-purchase-game__info__remove-game">
            <RemoveGame onClick={() => removeGame(game.id)} />
          </div>
        </div>
        <div className="action-purchase-game__play">
          <BaseButton to={ROUTES.PAYMENT_PAGE}>
            {t("personal_acc.pay")}
          </BaseButton>
        </div>
      </div>
    </div>
  );
}
